module.exports = __webpack_public_path__ + "static/media/imagemissing.65e768d4.png";


/*****************
 ** WEBPACK FOOTER
 ** ./src/img/imagemissing.png
 ** module id = 291
 ** module chunks = 0
 **/